import { NavLink } from 'react-router-dom';
import { BookMarked, LayoutGrid, Heart, Clock, FolderOpen, Settings, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export const Sidebar = () => {
  return (
    <div className="flex h-full w-64 flex-col border-r bg-sidebar p-4">
      <div className="mb-6 flex items-center gap-2">
        <div className="flex h-8 w-8 items-center justify-center rounded-md bg-primary text-primary-foreground">
          <BookMarked className="h-5 w-5" />
        </div>
        <span className="text-xl font-bold tracking-tight">stashmark</span>
      </div>

      <div className="mb-8">
        <Button className="w-full justify-start gap-2 rounded-xl bg-primary hover:bg-primary/90">
          <Plus className="h-4 w-4" />
          Add New Bookmark
        </Button>
      </div>

      <div className="flex flex-1 flex-col gap-6">
        <div>
          <h3 className="mb-2 px-2 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
            Main Menu
          </h3>
          <nav className="flex flex-col gap-1">
            <NavLink
              to="/"
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                  isActive
                    ? 'bg-secondary text-secondary-foreground'
                    : 'text-muted-foreground hover:bg-secondary/50 hover:text-foreground'
                )
              }
            >
              <LayoutGrid className="h-4 w-4" />
              All Bookmarks
            </NavLink>
            <NavLink
              to="/favorites"
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                  isActive
                    ? 'bg-secondary text-secondary-foreground'
                    : 'text-muted-foreground hover:bg-secondary/50 hover:text-foreground'
                )
              }
            >
              <Heart className="h-4 w-4" />
              Favorites
            </NavLink>
            <NavLink
              to="/recent"
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                  isActive
                    ? 'bg-secondary text-secondary-foreground'
                    : 'text-muted-foreground hover:bg-secondary/50 hover:text-foreground'
                )
              }
            >
              <Clock className="h-4 w-4" />
              Recently Added
            </NavLink>
          </nav>
        </div>

        <div>
          <h3 className="mb-2 px-2 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
            Folders
          </h3>
          <nav className="flex flex-col gap-1">
            <button className="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium text-muted-foreground transition-colors hover:bg-secondary/50 hover:text-foreground">
              <FolderOpen className="h-4 w-4" />
              Design Inspiration
            </button>
            <button className="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium text-muted-foreground transition-colors hover:bg-secondary/50 hover:text-foreground">
              <FolderOpen className="h-4 w-4" />
              Work Projects
            </button>
            <button className="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium text-muted-foreground transition-colors hover:bg-secondary/50 hover:text-foreground">
              <FolderOpen className="h-4 w-4" />
              Learning
            </button>
          </nav>
        </div>
      </div>

      <div className="mt-auto">
        <button className="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium text-muted-foreground transition-colors hover:bg-secondary/50 hover:text-foreground">
          <Settings className="h-4 w-4" />
          Settings
        </button>
      </div>
    </div>
  );
};
